/**
 * 新增广告组
 */

import { Modal, Button, Form, Input, InputNumber, Cascader, Radio } from 'antd';
import React, { useEffect, useState } from 'react';
import { VerifyEditFormData } from '../../type';
import { MatCascadeItemL1, GROUP_TYPE } from '../../interface';
import materialApi from '../../api';

interface AdvertGroupIdentifyListItem {
  value: string;
  label: string;
  selectable?: boolean;
  children?: AdvertGroupIdentifyListItem[];
}
interface IAdvertAddGroupProps {
  visible: boolean;
  onCancel: () => void;
  handleOk: (data: { name: string; totalNum: number; poolStyle: number; advertGroupIdentify: number }) => void;
  type: string;
  whiteList: string[];
}

const AdvertAddGroup = (props: IAdvertAddGroupProps) => {
  const { visible, onCancel, handleOk, whiteList } = props;
  const [addFormRef] = Form.useForm<VerifyEditFormData>();
  const [cascadeList, setCascadeList] = useState<MatCascadeItemL1[]>([]);
  const [babelStyleInfo, setBabelStyleInfo] = useState<{ styleId: number; styleName: string }[]>([]);
  const [loading, setLoading] = useState(true);
  const [advertGroupIdentify, setAdvertGroupIdentify] = useState('');

  const handleSave = async () => {
    try {
      const res = await addFormRef.validateFields();
      const data = {
        advertGroupIdentify: Number.parseInt(advertGroupIdentify as string, 10),
        name: res.name,
        totalNum: res.totalNum,
        poolStyle: Number.parseInt((res.poolStyle as string) || '0', 10),
      };
      handleOk(data);
    } catch (e) {}
  };

  const filterGroupIdentifyList = (
    list: AdvertGroupIdentifyListItem[],
    cascade: MatCascadeItemL1[],
    userWhitelist?: string[]
  ): AdvertGroupIdentifyListItem[] => {
    if (userWhitelist) {
      return list
        .filter((item) => {
          const c = cascade.find((it) => it.businessId === item.value);
          return !c || !c.ext.whitelist || userWhitelist.includes(c.ext.whitelist);
        })
        .map((item) => {
          if (item.children) {
            return Object.assign({}, item, {
              children: filterGroupIdentifyList(item.children, cascade, userWhitelist),
            });
          }
          return item;
        });
    }
    return list;
  };

  const staticList: AdvertGroupIdentifyListItem[] = filterGroupIdentifyList(
    [
      {
        value: '测试',
        label: '测试',
        selectable: false,
        children: [
          { value: '5002', label: '京东健康' },
          { value: '1061', label: '领券中心-优惠券' },
          { value: '1074', label: '全渠道优惠券' },
          { value: '5004', label: '京东到家-门店' },
          { value: '5003', label: 'LBS门店' },
          { value: '5005', label: '万家门店' },
          { value: '5006', label: '中心化频道' },
          { value: '5008', label: '裂变优惠券' },
          { value: '1088', label: '智能合图' },
        ],
      },
      {
        value: '99',
        label: '其他',
        selectable: false,
        children: [
          { value: '69', label: '赛马' },
          { value: '1067', label: '附近门店的优惠券' },
          { value: '70', label: '优惠券广告组' },
          // {value:'1026',label:'京豆换券'},
          { value: '1006', label: '京豆营销计划' },
          { value: '1027', label: '品类标签BI' },
          { value: '1065', label: '榜单' },
          { value: '1087', label: '粉丝分层权益' },
          { value: '1092', label: '互动营销奖品' },
          { value: '1094', label: '京喜优惠券奖池' }, // lowcode 需要重写创建页面走积木化搭建仓库
        ],
      },
      {
        value: '66',
        label: '通用',
      },
      {
        value: '908',
        label: '商家会员',
        selectable: false,
        children: [{ value: '1080', label: '广告+优惠券+商品组' }],
      },
      {
        value: '101',
        label: 'PC首页',
        children: babelStyleInfo.map((info) => ({ value: String(info.styleId), label: info.styleName })) || [],
      },
      {
        value: '102',
        label: '国际大牌',
        selectable: false,
        children: [
          { value: '111', label: '广告+商品组' },
          { value: '112', label: '带角标广告' },
          { value: '113', label: '全部大牌页广告' },
        ],
      },
      {
        value: '黄金流程',
        label: '黄金流程',
        selectable: false,
        children: [{ value: '92', label: '乐高品类广告组' }],
      },
      {
        value: '赛马',
        label: '赛马',
        selectable: false,
        children: [{ value: '90', label: '晋升赛道(4倍高)' }],
      },
      {
        value: '闪购活动',
        label: '闪购活动',
        selectable: false,
        children: [{ value: '1007', label: '外露商品样式' }], // 闪购需求：去掉 {value:1008,label:'不外露商品样式'},{value:1009,label:'无主图样式'}
      },
      {
        value: '促销优惠券',
        label: '促销优惠券',
        selectable: false,
        children: [
          { value: '1005', label: '优惠券+商品组' },
          { value: '1073', label: '优惠券+商品' },
          { value: '1059', label: '红包雨优惠券' },
        ],
      },
      {
        value: '1004',
        label: '金融优惠券',
      },
      {
        value: '品牌特卖',
        label: '品牌特卖',
        selectable: false,
        children: [
          { value: '1002', label: '定时素材' },
          { value: '1056', label: '名品特购' },
        ],
      },
      {
        value: '素材共享',
        label: '素材共享',
        selectable: false,
        children: [
          { value: '5', label: '一行两个（高样式）' },
          { value: '6', label: '双图（中样式）' },
          { value: '7', label: '双图（低样式）' },
          { value: '8', label: '三图（高样式）' },
          { value: '9', label: '三图（中样式）' },
          { value: '10', label: '三图（低样式）' },
          { value: '11', label: '四图（高样式）' },
          { value: '12', label: '四图（中样式）' },
          { value: '13', label: '四图（低样式）' },
          { value: '50', label: '批量录入的店铺广告组1' },
          { value: '51', label: '批量录入的店铺广告组2' },
          { value: '57', label: '会逛批量录入店铺广告组' },
          { value: '115', label: '店铺领券样式' },
        ],
      },
      {
        value: 'PLUS活动',
        label: 'PLUS活动',
        selectable: false,
        children: [
          { value: '1022', label: 'PLUS活动' },
          { value: '1058', label: 'PLUS优惠券' },
          { value: '1079', label: 'PLUS利益点' },
          { value: '1084', label: 'PLUS生活特权' },
        ],
      },
      {
        value: '1033',
        label: '一号店',
        selectable: false,
        children: [
          { value: '1023', label: '超级品牌' },
          { value: '1024', label: '超级品类' },
        ],
      },
      {
        value: '1044',
        label: '会员频道',
        selectable: false,
        children: [
          { value: '1046', label: '会员广告' },
          { value: '1047', label: '会员优惠券' },
        ],
      },
      {
        value: '内容素材',
        label: '内容素材',
        selectable: false,
        children: [{ value: '1085', label: '视频' }],
      },
      {
        value: '1068',
        label: '买家秀',
      },
      {
        value: '1071',
        label: '搭配购',
      },
      {
        value: '1072',
        label: '我京黑卡',
      },
      {
        value: '1082',
        label: '京东健康内容',
      },
      { value: '1083', label: 'UGC晒单' },
      { value: '122', label: '内容&经海路' }, // 原来“内容中台”更改为“内容&经海路”
      { value: '1086', label: '商品组间BI' },
      { value: '1091', label: '品牌商品券' },
    ],
    cascadeList || [],
    whiteList
  );

  const renderOther = () => {
    if (!advertGroupIdentify) {
      return null;
    }
    // 场次类型
    let options: { label: string; value: string }[] = [];
    if (advertGroupIdentify === '1065') {
      options = [
        { value: '0', label: '常规广告组' },
        { value: '2', label: '扩容广告组' },
      ];
    } else {
      // formData.poolStyle = void 0;
    }
    if (!options.length) {
      return null;
    }
    return (
      <Form.Item name="poolStyle" label="是否扩容" initialValue={options[0]?.value}>
        <Radio.Group>
          {options?.map((item) => {
            return (
              <Radio value={item.value} key={item.value}>
                {item.label}
              </Radio>
            );
          })}
        </Radio.Group>
      </Form.Item>
    );
  };

  const handleChange = (value: any) => {
    const id = value[value.length - 1];
    setAdvertGroupIdentify(id);
  };

  const filterCascadeInfoList = (list: MatCascadeItemL1[], userWhitelist?: string[]): MatCascadeItemL1[] => {
    if (userWhitelist) {
      return list.filter((p) => !p.ext.whitelist || userWhitelist.includes(p.ext.whitelist));
    }
    return list;
  };
  const createGroupIdentifyValueSet = (list: AdvertGroupIdentifyListItem[], set = new Set<string>()) => {
    list.forEach((item) => {
      if (item.children) {
        createGroupIdentifyValueSet(item.children, set);
      }
      if (set.has(item.value)) {
        console.error(`Duplicated group create tree value: ${item.label} (${item.value})`);
      }
      set.add(item.value);
    });
    return set;
  };

  const lowcodeList: AdvertGroupIdentifyListItem[] = filterCascadeInfoList(cascadeList || [], whiteList)
    .filter((c) => c.ext?.groupType === GROUP_TYPE.ADVERT)
    .map((c) => ({ value: c.businessId, label: c.name }));
  // 静态配置项值生成
  const staticValueSet = createGroupIdentifyValueSet(staticList);
  // 低代码类型过滤静态列表中已有的
  const advertGroupIdentifyList = [...staticList, ...lowcodeList.filter((item) => !staticValueSet.has(item.value))];

  const fetchBabelStyleInfo = async () => {
    if (babelStyleInfo.length > 0) {
      return;
    }
    await materialApi
      .queryBabelStyleInfo({ styleType: '3' })
      .then((res) => {
        setBabelStyleInfo([{ ...res.data.styleInfoList }]);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  const fetchCascadeList = async () => {
    if (cascadeList.length > 0) {
      return;
    }
    await materialApi
      .queryMatCascadeList({ parentId: 0 })
      .then((res) => {
        const list: MatCascadeItemL1[] = [];
        res.data.cascadeInfoList.forEach((p: any) => {
          if (p.level === 1) {
            list.push(p);
          }
        });
        setCascadeList([...list]);
        return res;
      })
      .catch((error) => {
        throw error;
      });
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      await Promise.all([fetchCascadeList(), fetchBabelStyleInfo()])
        .then((res) => {
          setLoading(false);
          return res;
        })
        .catch((error) => {
          throw error;
        });
    };
    fetchData();
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return (
    <Modal title="新增广告组" visible={visible} onCancel={onCancel} confirmLoading={loading} footer={null}>
      {/* <Spin spinning={loading}> */}
      <Form form={addFormRef}>
        <Form.Item name="name" label="广告组名称" rules={[{ required: true, message: '必填' }]}>
          <Input />
        </Form.Item>
        <Form.Item name="totalNum" label="展示数量" rules={[{ required: true, message: '必填' }]}>
          <InputNumber style={{ width: 100 }} />
        </Form.Item>
        <Form.Item name="advertGroupIdentify" label="广告组类型" rules={[{ required: true, message: '必填' }]}>
          {advertGroupIdentifyList.length > 0 && (
            <Cascader options={advertGroupIdentifyList} onChange={handleChange} changeOnSelect />
          )}
        </Form.Item>
        {renderOther()}

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={() => onCancel()}>取消</Button>
          <Button type="primary" htmlType="submit" style={{ marginLeft: 10 }} onClick={handleSave}>
            确定
          </Button>
        </div>
      </Form>
      {/* </Spin> */}
    </Modal>
  );
};

export default AdvertAddGroup;
